import { useTranslation } from 'react-i18next';
import LoadingSpinner from '../components/lib/UI/loadingSpinner/LoadingSpinner';
import { useAppSelector } from 'setup/store';
import UITable, { DisplayItem, RowItem } from 'components/lib/UI/table/UITable';
import { IPageData } from 'common/interfaces';
import { useEffect, useState } from 'react';
import { useAccessActions } from 'actions/access-actions';
import ErrorBox from 'components/lib/error-box';
import SearchInput from 'components/lib/search-input/SearchInput';
import { useUserActions } from 'actions/user-actions';
import { IUser } from 'common/interfaces/iuser';
import PersonIcon from '@mui/icons-material/Person';
import { useNavigate } from 'react-router-dom';
import { Alert, Box, Button } from '@mui/material';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { Link } from 'react-router-dom';
import { UserRolePriority, UserRoleTypeEnum } from 'common/constants/user';

const headers: DisplayItem[] = [
  {
    label: '#',
  },
  {
    label: 'Name',
  },
  {
    label: 'Role',
  },
  { label: 'Username' },
  { label: 'Email' },
  { label: '' },
];

const UsersPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const users = useAppSelector((store) => store.userReducer.users);
  const loading = useAppSelector((store) => store.userReducer.loading);
  const error = useAppSelector((store) => store.userReducer.error);
  const appConfig = useAppSelector((state) => state.appReducer.appConfig);
  const roleIdMap = useAppSelector((state) => state.userReducer.roleIdMap);
  const loggedInUser = useAppSelector((store) => store.appReducer.loggedInUser);
  const [errorMsg, setErrorMsg] = useState<string | null>(null);
  const [enableAddUser, setEnableAddUser] = useState<boolean>(true);

  const { loadAllUsers, loadAllRoles, searchUsers } = useUserActions();

  const [_users, setUsers] = useState<IPageData<IUser>>();
  const [searchText, setSearchText] = useState<string>('');

  const keyExtractor = (item: IUser, index: number) => {
    return (item.id || index).toString();
  };

  useEffect(() => {
    if (loggedInUser && loggedInUser?.roleId && roleIdMap) {
      if (roleIdMap[loggedInUser.roleId].priority <= UserRolePriority[UserRoleTypeEnum.STORE_ADMIN]) {
        setEnableAddUser(false);
      }
    }
  }, [loggedInUser, roleIdMap]);

  useEffect(() => {
    if (searchText && searchText?.length > 0) {
      _searchUsers(searchText, 1, appConfig.defaultListSize);
    } else {
      setUsers(users || ({} as IPageData<IUser>));
    }
  }, [users]);

  useEffect(() => {
    console.log('Mounted storeScreen.....1', users);
    loadAllUsers(1, appConfig.defaultListSize);
    loadAllRoles();
  }, []);

  const _searchUsers = async (text: string, pageNo: number, pageSize: number) => {
    console.log('_onSearchTermChange:::', text);
    setSearchText(text || '');
    setErrorMsg(null);
    if (text && text?.length > 1) {
      const resp = await searchUsers(pageNo, pageSize, {
        term: text,
        roleIds: [],
      });
      if (resp && resp?.totalItems > 0) {
        setUsers(resp);
        return resp;
      } else {
        setUsers({} as IPageData<IUser>);
        setErrorMsg("Oops! We couldn't find any users matching your search.");
      }
    } else if (!text) {
      setUsers(users || ({} as IPageData<IUser>));
    }
  };
  const _onSearchTermChange = (text?: string) => {
    console.log('_onSearchTermChange:::', text);
    setSearchText(text || '');
    if (text && text?.length > 2) {
      _searchUsers(text, 1, appConfig.defaultListSize);
    } else if (!text) {
      setUsers(users || ({} as IPageData<IUser>));
    }
  };
  function _fetchMoreData(pageNo: number, pageSize: number): Promise<IPageData<IUser> | undefined> {
    console.log('_fetchMoreData:::', pageNo, pageSize);
    if (searchText && searchText.length > 0) {
      return _searchUsers(searchText, pageNo, pageSize);
    }
    return loadAllUsers(pageNo, pageSize);
  }

  const _onItemPressed = (id?: number) => {
    console.log('_onItemPressed:::', id);
    const store = users?.items?.find((str) => str.id === id);
    //navigate to add store.
  };

  const _onEditPressed = (id?: number) => {
    console.log('_onEditPressed:::', id);
    const store = users?.items?.find((str) => str.id === id);
    //navigate to add store.
  };

  const _handleItemPressed = (item: IUser) => {
    navigate('/users/' + item.uuId);
  };

  const _handleChangePasswordAction = (item: IUser) => {
    console.log('_handleChangePasswordAction');

    navigate('/users/change-password/' + item.uuId);
  };

  const _renderRow = (item: IUser, index: number): RowItem => {
    return {
      id: item.id,
      index,
      data: [
        {
          label: index + 1 + '',
        },
        {
          label: item.displayName,
          icon: <PersonIcon />,
        },
        {
          label: roleIdMap ? roleIdMap[item.roleId].displayName || '' : '',
        },
        {
          label: item.username,
        },
        {
          label: item.email,
        },
        // {
        //   label: (item.zipcode || '-') + '',
        // },
      ],
    };
  };

  return (
    <section>
      <Box display="flex" flexDirection={{ xs: 'column', md: 'row' }} gap={2} className="pageTitleTitleContainer">
        <h2 className="pageTitle" style={{ flex: 1 }}>
          {t('page.users')}
        </h2>
        {enableAddUser ? (
          <Link to={'/users/add-new'}>
            <Button variant="contained">
              <AddCircleIcon /> &nbsp;Add New
            </Button>
          </Link>
        ) : null}
      </Box>
      {error ? <Alert severity="error"> {error.msg}</Alert> : null}
      <SearchInput onTextChanged={_onSearchTermChange} placeholder="Search Users" />
      <UITable<IUser>
        isLoading={loading}
        pagedData={_users}
        keyExtractor={keyExtractor}
        pageSize={appConfig.defaultListSize}
        loadData={_fetchMoreData}
        extractRowItem={_renderRow}
        headers={headers}
        onItemPressed={_handleItemPressed}
        actionItems={[{ actionKey: 'changePassword', handler: _handleChangePasswordAction }]}
      />
    </section>
  );
};

export default UsersPage;
